export const NavbarItems = [
    {
      title: "Home",
      url: "/",
      cName: "nav-links",
      icon: "fa-solid fa-clapperboard",
    },
    {
      title: "Gallery",
      url: "/gallery",
      cName: "nav-links",
      icon: "fa-solid fa-panorama",
    },
    {
      title: "About",
      url: "/about",
      cName: "nav-links",
      icon: "fa-solid fa-film",
    },
    {
      title: "Pricing",
      url: "/pricing",
      cName: "nav-links",
      icon: "fa-solid fa-video",
    },
    {
      title: "Contact",
      url: "/contact",
      cName: "nav-links",
      icon: "fa-solid fa-camera-retro",
    },
  ];
  